// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"styles_imageWrapper__sL2uO","image":"styles_image__i16xe"};